import React, { useState, useEffect, useCallback } from "react";
import "../../styles/desktop/main.css";

import CampoImagem from "../CampoImagem/campoimagem";
import Menu from "../menu/menu";
import TextMain from "../Texto Principal/textoMain";
import Agendamentos from "../Agendamento/agendamento";
import Loader from "../loader/loader";
import Exaustor from "../Exaustores/exaustores";
import Eventos from "../events/eventos";
import background from "../../assets/img/background.png";

import pagina1 from "../../assets/img/Pagina01.png";
import pagina2 from "../../assets/img/Pagina02.png";
import pagina3 from "../../assets/img/Pagina03.png";

import Grupo01 from "../Campo Luzes/Grupo01";
import Grupo02 from "../Campo Luzes/Grupo02";
import Grupo03 from "../Campo Luzes/Grupo03";
import AlarmeModal from "../Alarme/AlarmeModal";

import ChatBot from "../Plus/ChatBot/chatbot";
import PLUS from "../Plus/plus";
import Dispositivos from "../Plus/Dispositivos/dispositivo";
import Gestao from "../Gestao/gestao";
//import Notificacao from "../Notificacao/notificacao"; // Nova funcionalidade

// Hooks importados do código novo
import useEventos from "../../hooks/useEventos";
import useAlarmes from "../../hooks/useAlarmes";
import useMonitoramento from "../../hooks/useMonitoramento";

/**
 * Páginas que devem limpar a imagem central
 */
const alarmPages = [
  "CaixaDAgua",
  "CentralAlarmeIncendio", 
  "Bombas",
];

const clearImagePages = [
  "Agendamentos",
  "Alarme", 
  "Exaustor",
  "Gestao",
  "Chatbot",
  "PLUS",
  "Dispositivos", // Adicionado do código legado
  ...alarmPages, // inclui também as páginas de alarme
];

const Main = () => {
  const [paginaAtual, setPaginaAtual] = useState("Térreo");
  const [filtro, setFiltro] = useState("Todos"); // Nova funcionalidade
  const [loading, setLoading] = useState(true);
  const [loadingImage, setLoadingImage] = useState(false);
  const [imagemCentral, setImagemCentral] = useState(pagina1);

  // Hooks do código novo
  const { eventos, chamados, loading: eventosLoading, carregarEventos } = useEventos();
  const { caixas, bombas, status, alarmActive, tipoAlarmeAtivo } = useAlarmes();

  const {
    cieData,
    loading: monitoramentoLoading,
    fetchCieData,
    getDeviceStatus,
    formatDateTime,
    getActiveAlerts,
    getDeviceSeverity
  } = useMonitoramento();

  const monitoramentoUtils = {
    cieData,
    loading: monitoramentoLoading,
    fetchCieData,
    getDeviceStatus,
    formatDateTime,
    getActiveAlerts,
    getDeviceSeverity
  };

  console.log(imagemCentral);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 800);

    return () => clearTimeout(timer);
  }, []);

  /**
   * Exibe o loader antes de trocar a imagem central
   */
  const loaderImage = useCallback(() => {
    setPaginaAtual(pagina1);
    setLoadingImage(true);
    setTimeout(() => {
      setLoadingImage(false);
    }, 1000);
  }, []);

  /**
   * Troca a página atual. Se a página estiver em `clearImagePages`, limpa a imagem central.
   */
  const trocarPagina = useCallback((pagina) => {
    console.log(`Trocando para a página: ${pagina}`);
    
    if (clearImagePages.includes(pagina)) {
      setImagemCentral("");
    }
    if (pagina === "history") setFiltro("Todos");
    setPaginaAtual(pagina);
  }, []);

  /**
   * Troca a imagem central e dispara o loader
   */
  const trocarImagem = useCallback((img) => {
    if (imagemCentral !== img) {
      console.log("Imagem trocada para:", img);
      loaderImage();
      setImagemCentral(img);
    }
  }, [imagemCentral, loaderImage]);

  /**
   * Mapeamento entre imagens e componentes de grupo
   */
  const groupComponents = {
    [pagina1]: <Grupo01 />,
    [pagina2]: <Grupo02 />,
    [pagina3]: <Grupo03 />,
  };

  /**
   * Renderiza o grupo correspondente à imagem ou página atual
   */
  const renderGroup = () => {
    return groupComponents[imagemCentral] || groupComponents[paginaAtual] || null;
  };

  /**
   * Renderiza o conteúdo principal de acordo com a página atual
   */
  const renderPageContent = () => {
    // Primeiro, verifica se é uma página de alarmes
    if (alarmPages.includes(paginaAtual)) {
      return (
        <AlarmeModal 
          caixas={caixas} 
          bombas={bombas} 
          status={status} 
          page={paginaAtual} 
          monitoramentoUtils={monitoramentoUtils} 
        />
      );
    }

    switch (paginaAtual) {
      case "Agendamentos":
        return <Agendamentos />;
      case "Exaustor":
        return <Exaustor />;
      case "Chatbot":
        return <ChatBot />;
      case "history":
        return (
          <Eventos
            filtro={filtro}
            eventos={eventos}
            loading={eventosLoading}
            atualizarLista={carregarEventos}
            chamados={chamados}
          />
        );
      case "PLUS":
        return <PLUS />;
      case "Dispositivos":
        return <Dispositivos />;
      case "Alarme":
        return (
          <AlarmeModal 
            caixas={caixas} 
            bombas={bombas} 
            status={status} 
            monitoramentoUtils={monitoramentoUtils} 
          />
        );
      default:
        // Páginas que usam planta/fundo
        return (
          <>
            {imagemCentral && (
              <CampoImagem imagem={imagemCentral} loadingImage={loadingImage} />
            )}
            {renderGroup()}
          </>
        );
    }
  };

  return (
    <div id="divMain">
      {/* Combina os loadings do código legado e novo */}
      {(loading || eventosLoading) && <Loader />}

      <Menu
        trocarPagina={trocarPagina}
        trocarImagem={trocarImagem}
        paginaAtual={paginaAtual}
        paginas={[pagina1, pagina2, pagina3]}
        alarmStatus={alarmActive} // Nova funcionalidade
        tipoAlarmeAtivo={tipoAlarmeAtivo} // Nova funcionalidade
      />

      <div id="content" style={{ backgroundImage: `url(${background})` }}>
        <TextMain />
        {paginaAtual === "Gestao" ? (
          <Gestao />
        ) : (
          <div id="content-Central">{renderPageContent()}</div>
        )}
      </div>

      {/* 
      <Notificacao
        trocarPagina={trocarPagina}
        setFiltro={setFiltro}
        eventos={eventos}
      />
      */}
    </div>
  );
};

export default Main;